const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

// Obsolete, reserved and alias codes that CLDR still names; they would shadow the current ISO code (e.g. DD for Germany)
const NON_ISO_CODES = new Set(['AN', 'BU', 'CP', 'CS', 'DD', 'DG', 'EA', 'EU', 'FX', 'IC', 'NT', 'QU', 'SU', 'TA', 'TP', 'UK', 'VD', 'YU', 'ZR', 'ZZ']);

let nameToCode;

// Location names come from getLocations as English + selected-language records; match against English CLDR region names
const getNameToCode = () => {
  if (nameToCode) return nameToCode;
  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
  nameToCode = new Map();
  for (const a of LETTERS) {
    for (const b of LETTERS) {
      const code = a + b;
      const name = regionNames.of(code);
      if (!name || name === code || NON_ISO_CODES.has(code)) continue;
      const key = name.toLowerCase();
      if (!nameToCode.has(key)) nameToCode.set(key, code);
    }
  }
  return nameToCode;
};

// Backend names that differ from CLDR region names, or sub-national names
const NAME_OVERRIDES = {
  'bosnia and herzegovina': 'BA',
  'czech republic': 'CZ',
  'turkey': 'TR',
  'england': 'GB',
  'scotland': 'GB',
  'wales': 'GB',
  'north ireland': 'GB',
  'usa': 'US',
  'united states of america': 'US',
};

const SUB_REGION_PREFIXES = [
  ['usa-', 'US'],
  ['canada-', 'CA'],
];

export const countryNameToCode = (name) => {
  if (!name) return null;
  const key = String(name).trim().toLowerCase();
  if (NAME_OVERRIDES[key]) return NAME_OVERRIDES[key];
  const prefixed = SUB_REGION_PREFIXES.find(([prefix]) => key.startsWith(prefix));
  if (prefixed) return prefixed[1];
  return getNameToCode().get(key) || null;
};

// A location code has one record per language; return the first record whose name maps to an ISO code
export const getCountryCodeForLocation = (locations, locationCode) => {
  if (!Array.isArray(locations) || locationCode == null) return null;
  for (const location of locations) {
    if (String(location.locationCode) !== String(locationCode)) continue;
    const code = countryNameToCode(location.country);
    if (code) return code;
  }
  return null;
};

export const getRentalTermsUrl = (countryCode) =>
  `https://www.sixt.com/rental-information/${countryCode.toLowerCase()}/car/`;
